module.exports = __webpack_public_path__ + "img/logo_mmg.61746ac0.png";